// utils/authFetch.js
import { getToken } from "./auth";
import { reportServerVersion } from "./serverVersion";

export const authFetch = async (url, options = {}) => {
  const token = getToken();
  if (!token) {
    window.location.href = "/";
    throw new Error("No token");
  }

  const response = await fetch(url, {
    ...options,
    headers: {
      ...(options.headers || {}),
      Authorization: `Bearer ${token}`,
    },
  });
  reportServerVersion(response);
  return response;
};
